<template>
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00016 0.333328C4.25126 0.333328 2.8335 1.75109 2.8335 3.5C2.8335 5.2489 4.25126 6.66666 6.00016 6.66666C7.74906 6.66666 9.16683 5.2489 9.16683 3.5C9.16683 1.75109 7.74906 0.333328 6.00016 0.333328Z"
      fill="white"
    />
    <path
      d="M4.00016 7.66666C2.25126 7.66666 0.833496 9.08443 0.833496 10.8333C0.833496 12.5822 2.25126 14 4.00016 14H8.00016C9.74906 14 11.1668 12.5822 11.1668 10.8333C11.1668 9.08443 9.74906 7.66666 8.00016 7.66666H4.00016Z"
      fill="white"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "UserIcon",
})
</script>
